import { render, staticRenderFns } from "./HighCloudyImageBadge.vue?vue&type=template&id=179874d2&scoped=true"
import script from "./HighCloudyImageBadge.vue?vue&type=script&lang=ts"
export * from "./HighCloudyImageBadge.vue?vue&type=script&lang=ts"
import style0 from "./HighCloudyImageBadge.vue?vue&type=style&index=0&id=179874d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179874d2",
  null
  
)

export default component.exports